import { toTitleCase } from "../../../../Utils/stringUtls";
import ReviewAttribute from "../../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";
import ReviewSummarySectionHeading from "../../../../Components/SharedComponent/ReviewSummarySectionHeading/ReviewSummarySectionHeading";

const ContactSection = ({ heading, name, title, phone, cell, email, signApproval, className }) => (
  <>
    <div i2c-grid="12@md" className={`review-summary-section-heading font-semi-bold mb-0 mt-0 ${className}`}>
      {heading}
    </div>
    <ReviewAttribute label="Name" value={name ? toTitleCase(name) : '-'} />
    <ReviewAttribute label="Title" value={title ? toTitleCase(title) : '-'} />
    <ReviewAttribute label="Phone Number" value={phone ? phone : '-'} />
    <ReviewAttribute label="Cell Number" value={cell ? cell : '-'} />
    <ReviewAttribute label="Email" value={email ? email : '-'} />
    {signApproval !== undefined && (
      <div i2c-grid="12@md" className="attributes-wrapper">
        <div className="overview-help-text review-attribute-label">Does this person have signature approval?</div>
        <div className="overview-val-text">{toTitleCase(signApproval) || "-"}</div>
      </div>
    )}
  </>
);

const ContactInformationOverview = ({ data, type="debit" }) => {
  let data1 = data["0_3"];

    data1 = data["0_3"]
  
  const {
    cp_ci_pm_name,
    ci_businessName,
    cp_ci_pm_title,
    cp_ci_pm_phone_number,
    cp_ci_pm_cell_number,
    cp_ci_pm_email,
    cp_ci_pm_sign,
    cp_ci_sc_name,
    cp_ci_sc_title,
    cp_ci_sc_phone_number,
    cp_ci_sc_cell_number,
    cp_ci_sc_email,
    cp_ci_brn_name,
    cp_ci_brn_title,
    cp_ci_brn_phone_number,
    cp_ci_brn_cell_number,
    cp_ci_brn_email,
    cp_ci_mn_name,
    cp_ci_mn_title,
    cp_ci_mn_phone_number,
    cp_ci_mn_cell_number,
    cp_ci_mn_email,
    cp_ci_supp_name,
    cp_ci_supp_title,
    cp_ci_supp_phone_number,
    cp_ci_supp_cell_number,
    cp_ci_supp_email,
    cp_ci_ad_name,
    cp_ci_ad_title,
    cp_ci_ad_phone_number,
    cp_ci_ad_cell_number,
    cp_ci_ad_email,
    cp_ci_eep_name,
    cp_ci_eep_title,
    cp_ci_eep_phone_number,
    cp_ci_eep_cell_number,
    cp_ci_eep_email,
    cp_ci_ees_name,
    cp_ci_ees_title,
    cp_ci_ees_phone_number,
    cp_ci_ees_cell_number,
    cp_ci_ees_email,
  } = data1 ;

  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid" className="review-summary-gap">
        <ReviewSummarySectionHeading title="Key Contacts" />

        <ContactSection
          heading="Project Manager or Primary Contact for Program Management"
          className="review-summary-section-heading"
          name={cp_ci_pm_name}
          title={cp_ci_pm_title}
          phone={cp_ci_pm_phone_number}
          cell={cp_ci_pm_cell_number}
          email={cp_ci_pm_email}
          signApproval={cp_ci_pm_sign}
        />

        <ContactSection
          heading="Secondary Contact"
          name={cp_ci_sc_name}
          title={cp_ci_sc_title}
          phone={cp_ci_sc_phone_number}
          cell={cp_ci_sc_cell_number}
          email={cp_ci_sc_email}
        />

        <ContactSection
          heading="Contact for Business Release Notes"
          name={cp_ci_brn_name}
          title={cp_ci_brn_title}
          phone={cp_ci_brn_phone_number}
          cell={cp_ci_brn_cell_number}
          email={cp_ci_brn_email}
        />

        <ContactSection
          heading="Contact for Maintenance Notification"
          name={cp_ci_mn_name}
          title={cp_ci_mn_title}
          phone={cp_ci_mn_phone_number}
          cell={cp_ci_mn_cell_number}
          email={cp_ci_mn_email}
        />

        <ContactSection
          heading="Contact for Support"
          name={cp_ci_supp_name}
          title={cp_ci_supp_title}
          phone={cp_ci_supp_phone_number}
          cell={cp_ci_supp_cell_number}
          email={cp_ci_supp_email}
        />

        <ContactSection
          heading="Contact for Accounting Department"
          name={cp_ci_ad_name}
          title={cp_ci_ad_title}
          phone={cp_ci_ad_phone_number}
          cell={cp_ci_ad_cell_number}
          email={cp_ci_ad_email}
        />

        <ContactSection
          heading="Contact for Executive Escalation – Primary"
          name={cp_ci_eep_name}
          title={cp_ci_eep_title}
          phone={cp_ci_eep_phone_number}
          cell={cp_ci_eep_cell_number}
          email={cp_ci_eep_email}
        />

        <ContactSection
          heading="Contact for Executive Escalation – Secondary"
          name={cp_ci_ees_name}
          title={cp_ci_ees_title}
          phone={cp_ci_ees_phone_number}
          cell={cp_ci_ees_cell_number}
          email={cp_ci_ees_email}
        />
      </div>
      <div className="divider-bottom mt-16"></div>
    </div>
  );
};

export default ContactInformationOverview;
